import { BaseModel } from './BaseModel';
import Auth from './Auth';

export class SoftSkill extends BaseModel {
  static get entity() {
    return 'soft-skills';
  }

  static get fk() {
    return 'skill_id';
  }

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      ccsId: this.attr(null),
      title: this.attr(null),
      timestamp: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static get globalApiConfig() {
    const headers = {};
    const authToken = Auth.getAppToken();
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }
    return {
      baseURL: process.env.VUE_APP_SKILL_API_BASE_URL,
      headers
    };
  }

  static apiConfig = {
    actions: {
      async fetch() {
        return this.post(
          `/skill/soft-skills`,
          {},
          {
            dataTransformer: ({ data }) => {
              return data.map((item) => ({
                ...item,
                id: item.ccsId
              }));
            }
          }
        );
      }
    }
  };
}

export default SoftSkill;
